<template>
    <div
        v-show="hasFilters"
        class="l-ss-c-filters-container">
        <div class="l-ss-c-filters-top-container">
            <div
                v-show="showTopFilters"
                class="l-ss-c-filters-top-list"
                ref="topList">
                <div
                    v-if="$configuration.features.imageSearch && searchType === 'search-results'"
                    class="l-ss-c-search-image-block"
                    :class="{ 'l-ss-c-search-position-top': $configuration.layout.filterPosition === 'top' }"
                    @click="toggleImagePicker">
                    <i
                        class="l-ss-c-search-input-icon l-ss-c-search-input-icon-image"
                        v-html="iconImage"></i>
                    <span v-if="$configuration.layout.filterPosition === 'left'">
                        {{ $t('imageSearch.title') }}
                    </span>
                </div>
                <filter-container
                    v-for="filter in topFilters"
                    :key="filter.name"
                    :class="{ [`l-ss-c-filters-filter-${filter.type}`]: true, [`l-ss-c-filters-top-item`]: true }"
                    :filter="filter"
                    :has-results="hasResults"
                    :is-short="true"
                    :value="resolveValue(filter)"
                    :symbol="getSymbol(filter.id)"
                    @change="onFilterChange"
                    @filter-click="params => $emit('filter-click', params)"
                    :ref="changeQuantityFilter()"/>
            </div>
            <div
                class="l-ss-c-filters-all-top-actions"
                :class="[{ 'l-ss-c-filters-all-top-actions-left-position': filterPositionLeft }]">
                <slot name="actions-before"></slot>
                <div class="l-ss-c-all-filters-left-actions-side">
                    <button
                        v-if="shouldShowOpenFiltersButton"
                        :class="[{ ['l-ss-c-button-secondary']: hasSelected === false }]"
                        class="l-ss-c-button l-ss-c-filters-top-action l-ss-c-filters-top-action-filters l-ss-c-button-all-filter"
                        @click="() => $emit('open-filters')">
                        {{ $t('filters.titleAll') }}
                        <sup
                            v-if="hasSelected"
                            class="l-ss-c-filters-top-action-filters-count">{{ selectedCount }}</sup>
                    </button>
                </div>
                <span
                    class="l-ss-c-filters-found-items"
                    v-if="$screen.isMobile === false && !filterPositionLeft">
                    {{ foundItemsNumber }}
                </span>
                <sort
                    v-if="showSorting && $configuration.isSortVisible && !filterPositionLeft"
                    class="l-ss-c-filters-sort"
                    :sort-by="sortBy"
                    :sort-dest="sortDest"
                    @sort-change="params => $emit('sort-change', params)"
                    @result-sort-click="params => $emit('result-sort-click', params)"/>
            </div>
        </div>
    </div>
</template>

<script>
    import FilterMixin from './FilterMixin';
    import FoundItemsNumberMixin from '@/core/mixins/found-items-number-mixin';
    import Sort from '../../../core/components/sort';
    import iconToggleFilters from '../../../core/assets/images/icons/toggle-filters.svg';
    import { getCurrencyText } from '../../helpers/display';
    import imageIcon from '../../../core/assets/images/icons/image-search.svg';

    const DEFAULT_FILTERS_LENGTH = 2;

    export default {
        components: {
            Sort,
        },
        mixins: [
            FilterMixin,
            FoundItemsNumberMixin,
        ],
        props: {
            currency: {
                type: String,
                default: '',
            },
            hasSelected: {
                type: Boolean,
                default: false,
            },
            sortBy: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            showSorting: {
                type: Boolean,
                default: false,
            },
            filterPositionLeft: {
                type: Boolean,
                default: false,
            },
            searchType: {
                type: String,
                default: 'search-popup',
            },
        },
        data() {
            return {
                TOP_FILTERS_LENGTH: DEFAULT_FILTERS_LENGTH,
                WIDTH_FILTER: 120,
                HEIGHT_FILTER: 300,
            };
        },
        computed: {
            iconImage() {
                return imageIcon;
            },
            isOpened() {
                return this.$root.props.store.state.ui.isFiltersOpened;
            },
            showTopFilters() {
                return this.$screen.isMobile === false;
            },
            topFiltersLength() {
                return this.showTopFilters ? this.TOP_FILTERS_LENGTH : 0;
            },
            hasFilters() {
                return !!this.filters.length;
            },
            iconToggleFilters() {
                return iconToggleFilters;
            },
            checkFilters() {
                return this.filters.filter(item => !this.$configuration.hiddenFilters.includes(item.name));
            },
            topFilters() {
                return this.checkFilters.slice(0, this.topFiltersLength);
            },
            shouldShowOpenFiltersButton() {
                return this.checkFilters.length > this.topFiltersLength;
            },
            selectedCount() {
                return this.filters.filter(filter => !!this.resolveValue(filter)).length;
            },
        },
        methods: {
            toggleImagePicker(event) {
                this.$emit('toggle-image-picker', event);
            },
            getSymbol(filterType) {
                const currency = getCurrencyText(this.currency);
                return filterType === 'price' ? currency : '';
            },
            changeQuantityFilter() {
                if (this.filterPositionLeft && this.$parent.$refs['search-results']) {
                    this.$nextTick().then(() => {
                        this.TOP_FILTERS_LENGTH = 6;
                    });
                }
                if (!this.filterPositionLeft) {
                    this.$nextTick().then(() => {
                        let filterTopList = this.$refs.topList;
                        let widthBlock = Math.floor(filterTopList.offsetWidth / this.WIDTH_FILTER);
                        let width = (widthBlock > DEFAULT_FILTERS_LENGTH) ? widthBlock : DEFAULT_FILTERS_LENGTH;
                        this.TOP_FILTERS_LENGTH = width;
                    });
                }
            },
        },
    };
</script>
